// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/recogida-cars/list',
    name: 'recogida-cars-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/PtoRecogida.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_tags_pto_recogida_cars',
    },
  },
]

export default formTable
